const MINUTE = 1000 * 60;

export const STALE_TIME = 3 * MINUTE;
